import {eventHandler, mergeDeepObject, listener} from "./util";

const EVENT_KEY_HIDE= 'vg.dropdown.hide';
const EVENT_KEY_SHOW= 'vg.dropdown.show';

class VGDropdown {
	constructor(element, arg = {}) {
		if (!element) {
			console.error('Первый параметр не должен быть пустым');
			return false;
		} else {
			if (typeof element === 'string') {
				let $element = document.querySelector(element);
				if ($element) {
					this.element = $element;
				} else {
					console.error('В строке должен быть идентификатор боковой панели');
				}
			} else {
				this.element = element;
			}
		}

		this.settings = mergeDeepObject({
			button: null,
			backdrop: true,
			overflow: true,
		}, arg);

		this._addEventListener();
	}

	toggle() {
		return !this._isShow() ? this.show() : this.hide();
	}

	show() {
		let _this = this;

		_this.settings.button.classList.add('active');

		let rect = _this.settings.button.getBoundingClientRect();
		_this.element.style.left = rect.left + 'px';
		_this.element.style.top  = (rect.top + rect.height + 8) + 'px';

		_this.element.classList.add('show');
		_this._backdrop();
		_this._overflow();

		eventHandler.on(_this.element, EVENT_KEY_SHOW);
	}

	hide() {
		let _this = this;

		if (_this.settings.button) {
			_this.settings.button.classList.remove('active');
		}

		_this.element.classList.remove('show');
		_this._backdrop();
		_this._overflow();

		eventHandler.on(_this.element, EVENT_KEY_HIDE);
	}

	_isShow() {
		return this.element.classList.contains('show');
	}

	static getInstance(target, params = {}) {
		return new VGDropdown(target, params);
	}

	_overflow() {
		const _this = this;

		if (!_this.settings.overflow) return;

		if (!_this._isShow()) {
			document.body.style.overflow = '';
			document.body.style.paddingRight = '';
		} else {
			document.body.style.paddingRight = getWidth() + 'px';
			document.body.style.overflow = 'hidden';
		}

		function getWidth() {
			const documentWidth = document.documentElement.clientWidth
			return Math.abs(window.innerWidth - documentWidth)
		}
	}

	_backdrop() {
		let _this = this,
			backdrop = document.querySelector('.vg-dropdown-backdrop');

		if (!_this.settings.backdrop) return;

		if (backdrop) {
			backdrop.remove();
		} else {
			backdrop = document.createElement('div');
			backdrop.classList.add('vg-dropdown-backdrop');

			_this.element.after(backdrop);

			setTimeout(() => {
				backdrop.classList.add('show');
			}, 50);
		}
	}

	_addEventListener() {
		const _this = this;

		document.addEventListener('keyup', (e) => {
			if (e.key === "Escape") {
				_this.hide();
			}
		});

		if (!_this.settings.backdrop) {
			document.addEventListener('click', function (event) {
				let target = event.target.closest('.vg-dropdown-content');
				if (target !== _this.element) {
					_this.hide();
				}
			});
		}
	}
}

listener('click', '.vg-dropdown-backdrop', function (){
	let target = document.querySelector('.vg-dropdown-content.show'),
		btn = document.querySelector('[data-vg-toggle="dropdown"].active');

	const instance = VGDropdown.getInstance(target, {
		button: btn
	});
	instance.hide();

}, true);

export default VGDropdown;
